import React, {useState} from 'react';
import SelectLanguage from '../../OnboardingNew/GccComponents/SelectLanguage/SelectLanguage';
import PrivacyPolicyGccArabicContent from './PrivacyPolicyGccArabic';
import * as S from './PrivacyPolicy.stylesGcc';

const PrivacyPolicyGcc = () => {
  const [showArabicFlag, setShowArabicFlag] = useState(false);
  const [currentLang, setCurrentLang] = useState('english');

  const handleOnLanguageChange = option => {
    if (option.target.id === 'english') {
      document.querySelector('html').setAttribute('dir', 'ltr');
      setShowArabicFlag(false);
      setCurrentLang(option.target.id);
    } else {
      document.querySelector('html').setAttribute('dir', 'rtl');
      setShowArabicFlag(true);
      setCurrentLang(option.target.id);
    }
  };

  return (
    <S.PrivacyWrapper>
      <S.PrivacyHeader>
        <h2>
          {showArabicFlag
            ? 'الاتفاقية بين المستخدم وشركة ميكمايتريب للسفريات والسياحة ذ.م.م'
            : 'Privacy Policy - MakeMyTrip'}
        </h2>
        <SelectLanguage handleOptionChange={handleOnLanguageChange} currentLang={currentLang} />
      </S.PrivacyHeader>
      {showArabicFlag ? (
        <PrivacyPolicyGccArabicContent />
      ) : (
        <S.PrivacyContent>
          <h3>Applicability:</h3>
          <p>
            This Agreement along with Terms of Service (collectively, the "Terms of Use") forms the
            terms and conditions for the use of services and products (“Services”) of MakeMyTrip
            Travel & Tourism LLC ("MMT"). Any person entering into a travel partner arrangement
            ("User") and inquiring about or making a purchase of any Service provided by MMT through
            its websites i.e. https://mypartner.makemytrip.com/ and mobile applications
            (collectively referred to as "Website") agree to be governed by these Terms of Use. The
            User acknowledges and agrees that the Platform is a business to business (B2B) platform
            and provides services to business entities only. The User and MMT are individually
            referred to as 'Party' and collectively referred to as 'Parties' to these Terms of Use.
            The "Terms of Service" available on MMT's website sets out the terms & conditions
            applicable to the various Service offered by MMT. The User should refer to the relevant
            Terms of Service applicable for the Service booked by the User through the Website. The
            applicable Terms of Service for the respective Service shall binding on the User.
          </p>
          <h3>ELIGIBILITY TO USE</h3>
          <p>
            The User shall be eligible to access the Website in accordance with the applicable law
            of the land. Before using the Website or procuring the Services of MMT, the Users shall
            have compulsorily read and understand these Terms of Use and shall be deemed to have
            accepted the terms and conditions of these Terms of Use as a binding document that
            governs User's dealings and transactions with MMT. If the User does not agree with any
            part of these Terms of Use, then the User must not avail MMT's Services and must not
            access, browse or approach the Website. The User must be registered on the Platform to
            access or avail the Services for its commercial purposes. User agrees and acknowledges
            that User will transact on the Platform only for its business purposes and not for
            personal use. Except with MMT’s prior approval, one User may only register one account
            on the Platform. MMT may cancel or terminate a User’s account if MMT has reasons to
            suspect that the User has concurrently registered or controls two or more accounts. All
            rights and liabilities of the User and MMT with respect to any of the Services
            facilitated by MMT shall be restricted to the scope of these Terms of Use.
          </p>
          <h3>CONTENT</h3>
          <p>
            All content provided through the Website, including but not limited to audio, images,
            software, text, icons, proprietary logos, service marks, trademarks, graphics, figures,
            database rights and such other content (altogether referred to as "Content") are owned
            by or licensed to MMT, and protected under applicable intellectual property laws. User
            cannot use, copy, reproduce, license, adapt, distribute, exchange, modify, sell publish
            or translate, both electronically and otherwise, the Content for any other purpose,
            except as specified herein. The User also understands that, by using the Services or the
            Website, the User will not acquire any right, title or interest in or to the Content.
            User agrees to follow all the instructions provided by MMT from time to time which will
            prescribe the way a User may use the Content while accessing the Website. MMT does not
            grant the User a license, right or authority to utilize such Content in any manner. Any
            unauthorized use of the Content, will be in violation of the applicable law. MMT
            respects the intellectual property rights of others. If you notice any act of
            infringement on the Website, you are requested to send us a written notice of the
            alleged infringement which must include the following information
            <ul>
              <li> Clear identification of the protected work that you claim has been infringed</li>
              <li>
                Location of the material on the Website, including but not limited to the link of
                the infringing material
              </li>
              <li>Proof that the alleged infringed work is owned by you</li>
              <li>
                Your contact information. The aforesaid notices can be sent to MMT by email at
                legal@makemytrip.com.
              </li>
            </ul>
          </p>
          <h3>WEBSITE</h3>
          <p>
            The Website is meant to be used by bona fide User(s) only for a lawful purpose. This
            website is owned, controlled and managed by MakeMyTrip Travel & Tourism LLC. User(s)
            shall not distribute exchange, modify, sell or transmit anything from the Website,
            including but not limited to any text, images, audio and video, for any business,
            commercial or public purpose; nor shall the User(s) attempt (or encourage or support
            anyone else’s attempt) to circumvent, reverse engineer, decrypt, or otherwise alter or
            interfere with the Website and the content, or make unauthorized use thereof. These
            Terms of Use grants a limited, non-exclusive, non-transferable right to use this Website
            or the Services as expressly permitted in these Terms of Use. The User agrees not to
            interrupt or attempt to interrupt the operation of the Website in any manner whatsoever.
            Access to certain features of the Website may only be available to the registered
            User(s). The process of registration may require the User to answer certain questions or
            provide certain specific information that may or may not be personal in nature. Some
            such fields may be mandatory or optional. The User represents and warrants that all
            information supplied to MMT is true, complete and accurate. MMT reserves the right, in
            its sole discretion, to terminate or limit the access to the Website and the Services
            offered on the same or any portion thereof at any time, without notice, for general
            maintenance or any other reason whatsoever, without having to notify the User in this
            regard. MMT will make commercially reasonable endeavors to ensure that the Content on
            the Website is free of any virus or such other malwares. However, does not guarantee
            that the Website will be secure or free from viruses, and any data or information
            downloaded or otherwise obtained through the use of the Website is done entirely at the
            User's own discretion and risk, and the User shall be solely responsible for any damage
            to their computer systems or loss of data that may result from the download of such data
            or information. MMT reserves the right to periodically make improvements or changes to
            the Website at any time without any prior notice to the User. User(s) are requested to
            report any content on the Website which is deemed to be unlawful, objectionable,
            libelous, defamatory, obscene, harassing, invasive to privacy, abusive, fraudulent,
            against any religious beliefs, spam, or is violative of any applicable law to
            legal@makemytrip.com. On receiving such report, MMT reserves the right to investigate
            and/or take such action as the Company may deem appropriate. MMT may offer and generate
            various promotion codes, discount vouchers and run promotional offers (“collectively
            Promotional Offers”) from time to time which may be availed on the Website for discount,
            if applicable. MMT, at its sole discretion, may add, change or withdraw existing ones
            without any prior notice. All Promotional Offers mentioned on the Website are applicable
            and available only to the User(s) of MMT for legitimate bookings. Users, are not allowed
            to use the Website for making any fictitious or 'double’ bookings of the Services
            including for the purpose of unduly enriching itself with commissions or any Promotional
            Offers provided by MMT.
          </p>
          <h3>LIMITED LIABILITY OF MMT</h3>
          <p>
            MMT always acts as a facilitator by connecting the User with the respective service
            providers like airlines, hotels etc. (collectively referred to as "Service Providers").
            The User(s) shall be responsible for their own actions in utilizing the services
            purchased by the respective User, and MMT shall not be liable for any such action. By
            making a booking, User understands that MMT merely provides a technology platform for
            booking of services and products and the ultimate liability rests on the respective
            Service Provider and not MMT. Thus, the ultimate contract of service is directly between
            User and Service Provider. The User understands that breaching the rules and regulations
            set by the Service Provider, may result in cancellation of ticket and/or reservation.
            MMT's liability is limited to providing the User with a confirmed booking as selected by
            the User. In the event of non-confirmation of booking due to any technical reasons (like
            network downtime, disconnection with third party platforms such as payment gateways,
            banks etc.) or any other similar failures, MMT’s obligation shall be limited to
            refunding the booking amount, if any, received from the User. Such refund shall
            completely discharge MMT from all liabilities with respect to that transaction.
            Additional liabilities, if any, shall be borne by the User. <br />
            Any issues or concerns faced by the User at the time of availing any such Services shall
            be the sole responsibility of the Service Provider. MMT will have no liability with
            respect to acts, omissions, errors, representations, warranties, breaches or negligence
            on part of any Service Provider or to any cancellation, rescheduling or delay in the
            performance of the Services herein. Unless explicitly committed by MMT, MMT assumes no
            liability or makes no guarantee or representation towards the standard, quality, fitness
            or availability of the Services as provided by the respective Service Providers.
            Further, MMT shall not be held responsible if at the time of completing the transaction
            on the Website, the Service towards which the Booking is in process becomes no longer
            available or gets sold out. . The User further understands that the information
            displayed on the Website with respect to any Service is displayed as furnished by the
            Service Provider. MMT, therefore cannot be held liable in case if the information
            provided by the Service Provider is found to be inaccurate, incomplete, inadequate or
            obsolete or in contravention of any laws, rules, regulations or directions in force. In
            no event shall MMT be liable for any loss of use, data or profits, sales, business, or
            revenue, business interruption, loss of anticipated savings, loss of business
            opportunity, goodwill or reputation and/or any punitive, incidental, special, indirect
            or consequential loss or damage arising out of or in any way connected with the use or
            performance of the Services, the Website. Subject to the extent permitted by applicable
            laws, the maximum aggregate liability of MMT under these Terms of Use shall be limited
            to the booking amount paid towards making the booking in respect of which the dispute
            arose.
          </p>
          <h3>USER'S RESPONSIBILITY</h3>
          <p>
            The User understands that the use of the Website or Services is at the User’s sole risk
            and the Users are advised to review the description of the Services carefully before
            making a booking as they shall be bound by the terms and conditions contained in the
            booking confirmation or laid out in the confirmed booking voucher. These conditions are
            also to be read in consonance with the Terms of Services and regulations of the
            respective Service Providers as provided on the Website. If a User intends to make a
            booking on behalf of a third party, being legally authorized to act so, it shall be the
            responsibility of the User to inform such third party about the terms of this Terms of
            Use, including all rules and restrictions applicable thereto. The User undertakes to
            abide by all procedures and guidelines, as modified from time to time, in connection
            with the use of the Services available through MMT. The User further undertakes to
            comply with all applicable laws, regulations, orders, directions of any statutory,
            regulatory or judicial body empowered to do so for the use of Services or for each
            transaction. The User agrees not to use or allow third parties to use the Services as
            well as the Website for purposes other than those specified in these Terms of Use. In
            addition, the User agrees not to or allow third parties to:
            <ul>
              <li>disclose, or re-sell any login credentials to any third parties</li>
              <li>
                use the Website or avail the Services for any unauthorized commercial purposes
              </li>
              <li>make any speculative, false, or fraudulent bookings</li>
              <li>
                access, monitor or copy any content or information on the Website using any robot,
                spider, scraper or other automated means or any manual process for any purpose
                without MMT’s express prior written permission; damage, disable, impair, alter,
                circumvent, overburden, or take any action that imposes or may impose, in our
                discretion, an unreasonably or disproportionately large load on MMT’s infrastructure
              </li>
              <li>everse engineer or decompile any features or Services offered by MMT</li>
              <li>
                obtain or attempt to obtain any information by any means not intentionally made
                available through the Website
              </li>
              <li>
                re-sell, use, copy, monitor, display, download, or reproduce any content or
                information, software, products or services available on the Website for any
                commercial or competitive activity or purpose
              </li>
              <li>
                “frame”, “mirror” or otherwise incorporate any part of the Website into any other
                channel or website without our prior written authorization
              </li>
              <li>
                provide, directly or indirectly, materials that infringe intellectual property
                rights or any other rights of any third party
              </li>
              <li>
                impersonate a person, or otherwise misrepresent your affiliation with a person for
                the purposes of misleading, deceiving or defrauding another, or otherwise acting in
                an unlawful manner for unlawful purposes
              </li>
              <li>send unsolicited emails to any third parties</li>
              <li>upload viruses, malware, or other malicious codes on MMT’s systems</li>
              <li>act in a way that could cause damage to the Website, MMT or MMT’s reputation</li>
              <li>
                use Services on the Website in violation of any applicable laws, including the legal
                rights of others – this includes uploading content that violates third party
                intellectual property rights.
              </li>
            </ul>
            DISCLAIMER <br />
            The material on this Website could include technical inaccuracies or typographical
            errors. MMT may make changes or improvements at any time. The Services are provided on
            an "as is" and "as available" basis. MMT may change the features or functionality of the
            Services being provided at any time, in its sole discretion, without any prior notice or
            intimation to the User. To the maximum extent permitted by applicable mandatory laws,
            MMT expressly disclaims all warranties of any kind, whether express or implied,
            including, without limitation, any warranty for information, data, data processing
            services, uptime or uninterrupted access, any warranties concerning the availability,
            accuracy, usefulness, or content of information, and any warranties of title,
            non-infringement, merchantability or fitness for a particular purpose. No advice or
            information, whether oral or written, which the User obtains from MMT or through the
            Services opted shall create any warranty not expressly made herein or in the Terms of
            Service. The User acknowledges that this Website is provided only on the basis set out
            in these Terms of Use. The User’s uninterrupted access or use of this Website on this
            basis may be prevented by certain factors outside MMT’s reasonable control including,
            without limitation, the unavailability, inoperability or interruption of the Internet or
            other telecommunications services or as a result of any maintenance or other service
            work carried out on the Website. MMT does not accept any responsibility and will not be
            liable for any loss or damage whatsoever arising out of or in connection with any
            ability/inability to access or to use the Website. User also authorizes MMT's
            representative to contact such User over telephonic calls, SMS text messages and email
            including for marketing the Services availed by the User or those which are similar to,
            or comparable with, such Services, or such Services which we feel may be of interest to
            you. The User’s continued use of the Website is express indication of its consent for
            receiving such communication. This consent shall supersede any preferences set by such
            User the DNCR Registry or any other similar preferences.
          </p>
          <h3>SECURITY AND ACCOUNT RELATED INFORMATION</h3>
          <p>
            While registering on the Website, the User will have to choose a password to access the
            User's respective account and shall be solely responsible for maintaining the secrecy
            and confidentiality of the credentials as well as for all the activities undertaken
            thereon. It is the duty of the User to notify MMT immediately in writing of any
            unauthorized use of their password or credentials or any other breach of security. MMT
            will not be liable for any loss that may be incurred by the User as a result of
            unauthorized use of the password or credentials, either with or without the User's
            knowledge. The User shall not use anyone else's account at any time, without prior’s
            express consent. Any loss or misuse of login credentials must be reported to [.]
            immediately. The User acknowledges that any personal data (as defined in the Privacy
            Policy) which the User submits to or via MMT’s Services or Website may be used by MMT in
            accordance with its Privacy Policy and the applicable laws and registrations. The User
            agrees to ensure that all personal data provided is accurate and up to date and that the
            User has all consents, licenses or approvals necessary to allow MMT to use that
            information in accordance with these Terms of Use, the Privacy Policy, and the
            applicable law.
          </p>
          <h3>FEES AND PAYMENT</h3>
          <p>
            The User shall be completely responsible for all charges, fees, duties, taxes, and
            assessments arising out of the use of the Service, as per the applicable laws and
            regulations. In addition to the cost of booking as charged by the Service Providers, MMT
            reserves the right to charge certain fees in the nature of convenience fees. MMT further
            reserves the right to alter any and all fees from time to time. Any such additional
            fees, including fee towards any modifications thereof, will be displayed to the User
            before confirming the booking or collecting the payment from such User. In cases of
            short charging of the booking amount, taxes, statutory fee, convenience fee etc., owing
            to any technical error or other reason, MMT shall reserve the right to deduct, charge or
            claim the balance amount from the User and the User shall pay such balance amount to
            MMT. In cases where the short charge is claimed prior to the utilization of the booking,
            MMT will be at liberty to cancel such bookings if the amount is not paid before the
            utilization date. Any increase in the price charged by MMT on account of change in rate
            of taxes or imposition of new taxes, levies by Government shall have to be borne by the
            User. Such imposition of taxes, levies may be without prior notice and could also be
            retrospective but will always be as per applicable law. In the rare circumstance of a
            booking not getting confirmed for any reason whatsoever, MMT will process the refund of
            the booking amount paid by the User and intimate the User about the same. MMT is not
            under any obligation to provide an alternate booking in lieu of or to compensate or
            replace the unconfirmed booking. All subsequent bookings will be treated as new
            transactions. Any applicable refund will be processed as per the defined policies of the
            service provider and MMT as the case may be. The User agrees and understands that all
            payments shall only be made to bank accounts of MMT. MMT or its agents, representatives
            or employees shall never ask a customer to transfer money to any private account or to
            an account not held in the name of MMT. The User agrees that MMT shall not be held
            liable if the User transfers any amount against any booking or transaction to any bank
            account that is not legitimately held by MMT or to any personal account of any person.
            User shall not hold any right to recover from MMT any amount which is transferred by the
            User to any third party. The User will not share his personal sensitive information like
            credit/debit card number, CVV, OTP, card expiry date, user IDs, passwords etc. with any
            person including the agents, employees or representatives of MMT. The User shall
            immediately inform MMT if such details are demanded by any of its agents' employees or
            representatives. MMT shall not be liable for any loss that the User incurs for sharing
            the aforesaid details. Refunds, if any, on cancelled and/or missing bookings will always
            be processed to the respective account or the banking instrument (credit card, wallet
            etc.) from which payment was made for that booking. MMT under no circumstances is
            responsible for a User missing its flight or for a no-show or for any unutilized
            bookings. Refund, if any in such cases shall be as per the applicable policy of the
            Service Provider and shall be made to the User upon receipt of the same from the Service
            Provider. MMT further advise the User to make request for refund within 180 days of the
            missed check-in date (unless a shorter time period has been specified by the Service
            Provider), after which all amounts towards refund for no-show or unutilized bookings
            shall be deemed to be forfeited. Booking(s) made by the User through MMT are subject to
            the applicable cancellation policy as set out on the booking confirmation or as
            communicated to the Users in writing. MMT provides various modes of making payments on
            the Website for transacting, like Credit/Debit Cards of various banks, Net Banking
            facility of all major banks, MMT and third party Wallets, Gift Cards, and more. Any
            money deposited in the MMT wallet by the User will be maintained in the same form and
            currency as deposited, and this amount may be used by the User solely as a means of
            making payments for bookings made through the Website, in accordance with these Terms of
            Service.
          </p>
          <h3>USAGE OF THE MOBILE NUMBER, COMMUNICATION DETAILS OF THE USER BY MMT</h3>
          <p>
            MMT will send booking confirmation, cancellation request, payment confirmation, refund
            status, schedule change or any such other information relevant for the transaction or
            booking made by the User, via SMS, internet-based messaging applications like WhatsApp,
            voice call, e-mail or any other alternate communication detail provided by the User at
            the time of booking. Nevertheless, MMT is not responsible of the receipt by the User of
            the foregoing. MMT may also contact the User through the modes mentioned above for any
            pending or failed bookings, to know the preference of the User for concluding the
            booking and also to help the User for the same. The User hereby unconditionally consents
            that such communications via SMS, internet-based messaging applications like WhatsApp,
            voice call, email or any other mode used by MMT are:
            <ul>
              <li> upon the request and authorization of the User</li>
              <li>
                {' '}
                'transactional' and not “promotional' as per the rules and regulations of Telecom
                and Digital Regulation Authority of the UAE (“TDRA”), and{' '}
              </li>
              <li>
                {' '}
                in compliance with the relevant guidelines of TDRA or any such other authority in
                the UAE. The User will indemnify MMT against all types of losses and damages
                incurred by MMT due to any action taken by TDRA or any other authority due to any
                erroneous complaint raised by the User on MMT with respect to the communications
                mentioned above or due to a wrong number or email ID being provided by the User for
                any reason whatsoever.
              </li>
            </ul>
          </p>
          <h3>INSURANCE</h3>
          <p>
            Unless explicitly provided by MMT in any specific Service, obtaining sufficient
            insurance coverage is the obligation of the User. In no case MMT shall accept any claims
            arising out of such scenarios. Insurance, if any, provided as a part of the Service by
            MMT shall be as per the terms and conditions of the third-party insurance company. MMT
            merely acts as a facilitator in connecting the User with insurance company. The User
            shall contact the insurance company directly for any claims or disputes. MMT shall not
            be held liable in case of partial acceptance or denial of the claims by the insurance
            company.
          </p>
          <h3>OBLIGATION TO OBTAIN VISA</h3>
          <p>
            International bookings made through MMT are subject to the requirements of visa
            including but not limited to transit visa, OK TO BOARD which are to be obtained by the
            User as per the requirement of their travel bookings and the requirements of the
            countries the User intends to visit or transit through. MMT is not responsible for any
            issues, including inability to travel, arising out of such visa requirements and is also
            not liable to refund any amount to the User for being unable to utilize the booking due
            to absence or denial of visa, irrespective whether or not the User has availed the
            Services of MMT for the visa process. Refund, if any, will be as per the applicable
            terms of booking and cancellation policy of the respective Service Provider.
          </p>
          <h3>FORCE MAJEURE</h3>
          <p>
            There can be exceptional circumstances where MMT and / or the Service Providers may be
            unable to honor the confirmed bookings due to various reasons like act of God, labor
            unrest, insolvency, a pandemic, an epidemic, business exigencies, government decisions,
            terrorist activity, any operational and technical issues, route and flight cancellations
            etc. or any other reason beyond the reasonable control of MMT. If MMT has advance
            knowledge of any such situations where dishonor of bookings may happen, it will make its
            commercially reasonable efforts to provide similar alternative to the User or refund the
            booking amount after deducting applicable service charges, if supported and refunded by
            the relevant Service Provider(s). The User agrees that MMT being merely a facilitator of
            the Services booked, cannot be held responsible for any such Force Majeure circumstance.
            The User has to contact the Service Provider directly for any further resolutions and
            refunds.
          </p>
          <h3>ADVERTISERS ON MMT, AND THIRD PARTY OR LINKED WEBSITES</h3>
          <p>
            The Website may contain links to Service Provider’s or any third-party websites (“Third
            Party Websites”). MMT is providing these links to the Users only as a convenience, and
            MMT does not endorse nor control such websites and is not responsible for their
            respective contents. If a User accesses any Third-Party Website, the same shall be done
            entirely at the User's risk and MMT shall assume no liability or responsibility for the
            same. MMT is not liable for any errors, omissions or false representations on any of the
            pages, links or any linked sites on MMT’s Website (to the extent such information is
            updated or provided directly by the Service Providers or the advertisers) and/or on the
            Third Party Websites. MMT will not deal with or provide any Service to any of OFAC
            (Office of Foreign Assets Control) sanctions countries in accordance with the law of
            UAE.
          </p>
          <h3>RIGHT TO REFUSE</h3>
          <p>
            MMT, at its sole discretion, reserves the right to not accept any booking without
            assigning any reason thereof. <br />
            MMT will not provide any Service or share confirmed booking details until the complete
            consideration is received from the User. <br />
            In addition to other remedies and recourse available to MMT under these Terms of Use or
            under applicable law, MMT may (i) limit the User's activity, (ii) warn other users of
            the User's actions, (iii) immediately suspend or terminate the User’s registration, or
            (iv) refuse to provide the User with access to the Website; if:
            <ul>
              <li> The User is in breach of these Terms of Use or </li>
              <li>
                MMT is unable to verify or authenticate any information provided by the User or{' '}
              </li>{' '}
              <li>
                MMT believes or has reasons to believe that the User’s actions may infringe
                third-party rights or breach any applicable law or otherwise result in any liability
                for the User, other users of MMT, or MMT itself.
              </li>
            </ul>{' '}
            Once a User has been suspended or terminated, such User shall not register or attempt to
            register with MMT with different credentials, or use the Website in any manner
            whatsoever until such User is reinstated by MMT. The decision to reinstate a suspended
            User shall be made at MMT’s sole discretion. If a User breaches these Terms of Use, MMT
            reserves the right to recover any amounts due to be paid by the User to MMT (including
            by setting-off any amount which is due by the User to MMT under this Agreement), and to
            take appropriate legal action as it deems necessary. The User shall not write or send
            any content to MMT which is, or communicate with MMT using language or content which: Is
            abusive, threatening, offensive, defamatory, coercive, obscene, belligerent, glorifying
            violence, vulgar, sexually explicit, pornographic, illicit or otherwise objectionable.{' '}
            <ul>
              <li> Is contrary to any applicable law </li>
              <li>
                {' '}
                Contain software or other materials that violates any third parties’ intellectual
                property rights
              </li>{' '}
              <li>is a spam</li>{' '}
              <li>
                {' '}
                contains viruses, malware, corrupted files or any other similar software or programs
                that may damage the Website or
              </li>{' '}
              <li>
                {' '}
                Falsify the origin or source of software or other material contained in a file that
                is uploaded
              </li>
              <li>
                in breach of the terms and conditions under these Terms of Use or applicable law.
              </li>
            </ul>
            If the User violates any of the aforesaid terms, MMT shall be at liberty to take
            appropriate legal action against the User.
            <br /> <b>RIGHT TO REFUSAL BY SERVICE PROVIDER:</b> <br />
            User agrees that that the Service Provider may refuse to provide the Service(s), agreed
            to be provided to the User, for any booking made through MMT with and/or without
            assigning any reasons or owing to reasons including but not limited to behavioural
            issues, public safety, health hazards, infectious diseases, government
            orders/notification etc. In such scenarios of refusal, the liability shall solely vest
            with the Service Provider as it is outside the purview of MMT and the User agrees that
            any claim, refund ,damages or losses resulting from such refusal shall be solely raised
            against the Service Provider and not MMT.
          </p>
          <h3>RIGHT TO CANCEL</h3>
          <p>
            The User expressly undertakes to provide MMT with correct and valid information while
            making use of the Website as per these Terms of Use, and not to make any
            misrepresentation of facts. Any default on part of the User would disentitle the User
            from availing the Services from MMT. In case MMT discovers or has reasons to believe at
            any time during or after receiving a request for Services from the User, that such
            request is either unauthorized or that the information provided by the User or any of
            the travelers is not correct or that any fact has been misrepresented by that User, MMT
            shall be entitled to appropriate legal remedies against the User, including cancellation
            of the bookings, without any prior notice to the User. In such an event, MMT shall not
            be responsible or liable for any loss or damage that may be caused to the User or any
            other person concerned by the booking, as a consequence of such cancellation of booking
            or Services. If any judicial, quasi-judicial, investigation agency, government authority
            approaches MMT to cancel any booking, MMT will cancel the same without having to notify
            the User in question. The User shall not hold MMT responsible for any loss or damage
            arising out of measures taken by MMT for safeguarding its own interest and that of its
            genuine customers. This would also include MMT denying or cancelling any bookings on
            account of suspected fraudulent transactions.
          </p>
          <h3>FAKE CALLS AND OTHER SIMILAR PHISHING, SPAMMING OR FRAUDULENT ACTIVITIES</h3>
          <p>
            MMT's employees or authorized representatives will never contact a User asking for his/
            her credit or debit card number, expiry date, CVV, net banking login, passwords, OTP
            etc. nor will they ever request for a fund transfer to a personal or an individual bank
            account. Further, they will also not ask a User to install any third-party applications
            that enable them to view a User's mobile or computer screen. Acting on any of these
            requests may make you a victim of fraud, and may potentially lead to loss of your
            valuable money or information. If you are ever asked for any of the aforesaid
            information, please report it immediately on <b>legal@makemytrip.com</b>. The User
            understands and agrees that MMT will not be held liable for any loss or damage incurred
            by the User in relation to the foregoing.
          </p>
          <h3>COVID-19 RELATED TERMS & CONDITIONS:</h3>
          <p>
            User agrees that due to the outbreak of COVID-19 pandemic, there may be instances where
            the Service Provider either cancels the booking or refuses to provide the Services, as
            agreed with the User (including without assigning any specific reason for such refusal).
            Refusal of Service may be due to the reasons including but not limited to the User:
            <ul>
              <li>exhibiting any symptoms associated with COVID 19</li>
              <li>
                refusing to comply with safety advisories, like wearing protective gear, complying
                with social distancing norms etc.
              </li>
              <li>suffering of any ailment making the User vulnerable to the virus</li>
              <li>posing a threat to the health and safety of others</li>
              <li>not fulfilling Covid-19 vaccination criteria.</li>
            </ul>
            In such cases MMT will assume no liability for the refusal of Service by the Service
            Provider. The User also agrees that refund, if any, for such bookings will be processed
            by MMT to the User subject to receipt of the amount from the Service Provider and with
            accordance to the Service Provider’s internal policy. User agrees and warrants to comply
            with all rules, regulations, guidelines or standard operating procedures that the User
            is required to follow in accordance with applicable laws of all relevant jurisdictions,
            in order to utilize the Services booked.
          </p>
          <h3>MISCLLEANEOUS</h3>
          <p>
            SEVERABILITY: If any provision of this User Agreement is determined to be invalid or
            unenforceable in whole or in part, such invalidity or unenforceability shall attach only
            to such provision or part of such provision and the remaining part of such provision and
            all other provisions of this User Agreement shall continue to be in full force and
            effect.
            <br />
            JURISDICTION: This User Agreement is subject to interpretation as per the laws of the
            United Arab Emirates (“UAE”), and the parties shall refer any unresolved disputes to the
            exclusive jurisdiction of courts in Dubai, UAE. <br />
            AMENDMENT TO THESE TERMS OF USE: MMT reserves the right to change these Terms of Use
            from time to time. The User is responsible for regularly reviewing these Terms of Use,
            to ensure that the User is aware of any changes we have made, as they are binding on the
            User. The User’s continued use of the Website after any such changes are posted will be
            considered acceptance of such changes. <br />
            CONFIDENTIALITY: Any information which is specifically mentioned by MMT as confidential
            shall be maintained confidentially by the User and shall not be disclosed unless as
            required by law or to serve the purpose of these Terms of Use and the obligations of
            both the parties herein.
            <br /> PRIVACY POLICY: User shall also refer to MMT's Privacy Policy available on MMT's
            Website By using the Website, User agrees to the terms of the Privacy Policy and
            accordingly consents to the use of the User’s personal data by MMT and its affiliates in
            accordance with the terms of the Privacy Policy and the applicable laws and regulations.
          </p>
          <S.PrivacyHeaderHeading>
            <h2>Terms of Service</h2>
          </S.PrivacyHeaderHeading>
          <h3>FLIGHT TICKETS</h3>
          <p>
            <b>TERMS OF THE AIRLINES</b>
            <br /> The airline tickets available through the Website are subject to the terms &
            conditions of the concerned airline, including but not limited to cancellation and
            refund policies. MMT merely acts as a facilitator to enable the User to book a flight
            ticket. The contract of service for utilization of the flight service is always between
            the User and the concerned airline. We recommend Users to refer to the terms and
            conditions of the airlines before making any booking. By confirming a ticket, the User
            agrees to be bound by the terms and conditions of the concerned airline. Airlines retain
            the right to reschedule flight times, route, change or cancel flights or itineraries
            independent of and without prior notification to MMT. As a facilitator, MMT has no
            control or authority over the logistics of the airlines and therefore, is not liable for
            any loss, direct or indirect, that a User may incur due to such change or cancellation
            of a flight. Different tickets on the same airline may carry different restrictions or
            include different services and price. The baggage allowance on the given fare is as per
            the terms decided by the airline, and MMT has no role to play in the same. Some of the
            fares shown in the booking flow are "hand baggage fares" which do not entitle the User
            for free check in baggage and therefore, the User will be required to pay separately for
            check in baggage. The prices for adding check-in baggage to a booking may vary from
            airline to airline. The User is advised to contact the airlines for detailed costs.
            <br />
            <b>CODE SHARE</b>
            <br />
            Some airlines enter into "code share" agreements with other Airlines. This means that on
            certain routes, the airline carrier selling or marketing the flight ticket does not fly
            its own aircraft to that destination. Instead, it contracts or partners with another
            airline to fly to that destination. The partner airline is listed as "operated by" in
            the booking flow. If your flight is a code share, it will be disclosed to you in the
            booking process and prior to making the payment. MMT will disclose all such code-share
            arrangements to the User, only when the ticketing airline discloses it to MMT in the
            first place.
            <br />
            <b>PRICING</b>
            <br />
            The total price displayed on the Website on the payment page usually includes base fare,
            applicable government taxes and convenience fee (nomenclature may vary). Users are
            required to pay the entire amount prior to the confirmation of their booking(s). In the
            event the User does not pay the entire amount, MMT reserves its right to cancel the
            booking. User agrees to pay all statutory taxes, surcharges and fees, as applicable on
            the date of travel. To avail infant fares, the age of the child must be under 24 months
            throughout the entire itinerary. This includes both onward and return journeys. If the
            infant is 24 months or above on the return journey, User will be required to make a
            separate booking using a child fare. Any infants or children must be accompanied by an
            adult as per the terms of the airlines.
            <br />
            <b>TRAVEL DOCUMENTS</b>
            <br />
            It shall be the sole responsibility of the User to ensure they are in possession of
            valid travel documents such as identity proof, passport, visa (including transit visa)
            etc. to undertake the travel. User agrees that in case of inability to travel for not
            carrying valid travel documents, MMT shall in no way be held liable. User understands
            that the information (if any) provided by MMT regarding the travel documents is only
            advisory in nature and can't be considered conclusive. The User shall ensure checking
            the requirements of travel with the respective airlines of the respective jurisdictions
            the User may transit through or choose to visit.
            <br />
            <b>CHECK-IN TERMS</b>
            <br />
            The User should check with the airlines directly regarding the check-in timings.
            Usually, check-in begins 2 hours before departure for domestic flights, and 3 hours
            before departure for international flights. User should carry valid identification
            proofs, passport, age proofs, etc. as may be required to prove the identity, nationality
            and age of the passengers travelling on a ticket, including infants.
            <br />
            <b>USE OF FLIGHT SEGMENTS</b>
            <br />
            In the event User does not embark on the onward journey, the entire passenger’s name
            record (PNR) pertaining to that booking shall be automatically cancelled by the airline.
            In such a scenario MMT has no control in the said process nor shall be obligated to
            provide alternate bookings to the User. The cancellation penalty in such an event shall
            be as per the applicable airline rules.
            <br />
            <b>CHANGES TO EXISTING BOOKING</b>
            <br />
            Any changes that are made to any existing booking shall be subject to certain charges
            levied by the respective airline, apart from the convenience fee charged by MMT. The
            User shall be obligated to pay applicable charges in the event of any alteration or
            modification to an existing booking. However, depending on the airline's policy and fare
            class, charges for changes or modifications to existing bookings may vary.
          </p>
          <h3>HOTELS</h3>
          <p>
            The Hotel services are not available for booking on the Website and thus, the below
            stated Hotels terms of service are not applicable. However, the same shall be become
            applicable and binding on the Users from the date MMT decides to go live with the Hotel
            services on the Website.
            <br />
            <b>ROLE OF MMT AND LIMITATION OF LIABILITY OF MMT</b>
            <br />
            MMT acts as a facilitator and merely provides an online platform to the User to select
            and book a particular hotel. Hotels in this context includes all categories of
            accommodations such as hotels, home-stays, bed and breakfast stays, farm-houses and any
            other alternate accommodations. All the information pertaining to the hotel including
            the category of the hotel, images, room type, amenities and facilities available at the
            hotel are as per the information provided by the hotel to MMT. This information is for
            reference only. Any discrepancy that may exist between the website pictures and actual
            settings of the hotel shall be raised by the User with the hotel directly, and shall be
            resolved between the User and hotel. MMT will have no responsibility in that process of
            resolution, and shall not take any liability for such discrepancies.
            <br />
            <b>INFORMATION FROM THE HOTEL AND THE TERMS OF THE HOTEL</b>
            <br />
            The hotel booking voucher which MMT issues to a User is solely based on the information
            provided or updated by the hotel regarding the inventory availability. In no
            circumstances shall MMT be held liable for failure on part of a hotel to accommodate the
            User with a confirmed booking, the standard of service or any insufficiency in the
            services, or any other service related issues at the hotel. The liability of MMT in case
            of denial of check-in by a hotel for any reason whatsoever including over-booking,
            system or technical errors, or unavailability of rooms etc., will be limited to either
            providing a similar alternate accommodation at the discretion of MMT (subject to
            availability at that time), or refunding the booking amount (to the extent paid) to the
            User. Any other service related issues should be directly resolved by the User with the
            hotel. Hotels reserves the sole right of admission and MMT has no say whatsoever in
            admission or denial for admission by the hotel. Unmarried or unrelated couples may not
            be allowed to check-in by some hotels as per their policies. Similarly, accommodation
            may be denied to guests posing as a couple if suitable proof of identification is not
            presented at the time check-in. Some hotels may also not allow local residents to
            check-in as guests. MMT will not be responsible for any check-in denied by the hotel due
            to the aforesaid reasons or any other reason not under the control of MMT. No refund
            would be applicable in case the hotel denies check-in under such circumstances.
            <br />
            <b>RESPONSIBILITIES OF THE USER</b>
            <br />
            The User would be liable to make good any damage(s) caused by any act of the User or
            their accompanying guests (including willfully or negligently) to the property of the
            hotel in any manner whatsoever. The extent and the amount of the damage so caused would
            be determined by the concerned hotel. MMT would not, in any way, intervene in the same.
            <br />
            The primary guest must be at least 18 years old to be able to check into the hotel.
            <br />
            The User has to be in possession of a valid identity proof and address proof, at the
            time of check-in. The hotel shall be within its rights to deny check-in to a User if a
            valid identity proof is not presented at the time of check-in.
            <br />
            Check-in time, check-out time, and any changes in those timings, will be as per hotel
            policy & terms. Early check-in or late check-out request is subject to availability and
            the hotel may charge an additional fee for providing such services.
            <br />
            <b>ADDITIONAL CHARGES BY THE HOTEL</b>
            <br />
            The booking amount paid by the User is only for stay at the hotel. Some bookings may
            include breakfast and/ or meals as confirmed at the time of booking. Any other services
            utilized by the User at the hotel, including laundry, room service, internet, telephone,
            extra food, drinks, beverages etc. shall be paid by the User directly to the hotel.
            <br />
            Hotels may charge a mandatory meal surcharge on festive periods like Christmas, New
            Year's Eve or other festivals as decided by the hotel. All additional charges (including
            mandatory meal surcharges) need to be settled directly at the hotel. MMT will have no
            control over waiving the same.
            <br />
            <b>PAYMENT FOR BOOKINGS AND ANY ADDITIONAL PAYMENTS</b>
            <br />
            Booking of a hotel can either be "Prepaid", or "Pay at hotel" as per the options made
            available by a hotel on the Website of MMT.
            <br />
            In "Prepaid" model, the total booking amount is paid by the User at the time of booking
            itself. Such total booking amount includes the hotel reservation rate, taxes, service
            fees as may be charged on behalf of the actual Service Provider, and any additional
            convenience fee charged by MMT.
            <br />
            At the hotel's or MMT's sole discretion on case to case basis, the User may also be
            provided with an option to make a part payment to MMT at the time of confirmation of a
            booking. The balance booking amount shall be paid as per the terms of the bookings.
            <br />
            For security purposes, the User must provide MMT with correct credit or debit card
            details. MMT may cancel the booking, at its sole discretion, in case such credit or
            debit card details as provided by the User are found incorrect or incomplete.
            <br />
            Payment can be made either in AED or any other foreign exchange/currency as specified at
            the time of booking on the Website.
            <br />
            Some banks and card issuing companies charge their account holders a transaction fee
            when the card issuer and the merchant location (as defined by the card brand, e.g. Visa,
            MasterCard, American Express) are in different countries. If a User has any questions
            about the fees or any exchange rate applied, they may contact their bank or the card
            issuing company through which payment was made.
            <br />
            Some accommodation suppliers may require User and/or the other persons, on behalf of
            whom the booking is made, to present a credit card or cash deposit upon check-in to
            cover additional expenses that may be incurred during their stay. Such deposit is
            unrelated to any payment received by MMT and solely at the behest of the Hotel.
            <br />
            In "Pay at hotel" model, the concerned hotel will collect the entire payment against the
            booking at the time of check-in. In case of international bookings, the payment will be
            charged in local currency or in any other currency, as decided by the hotel. For
            security purposes, the User must provide MMT with correct credit or debit card details.
            MMT may cancel the booking at its sole discretion in case such credit or debit card
            details as provided by the User are found incorrect or incomplete.
          </p>
        </S.PrivacyContent>
      )}
    </S.PrivacyWrapper>
  );
};

export default PrivacyPolicyGcc;
